/// <reference path="search.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../plugins/AppointmentBook/js/services/AppointmentBookActionsService.ts" />
/// <reference path="../filters/clientVisitDateFilter.ts" />
module Meevo.Components.Search {
    import ClientAlertTypeEnum = Meevo.Model.ClientAlertTypeEnum;
    "use strict";

    export class MeevoClientDetailAccordion implements angular.IDirective {
        private clientVisitFilter: angular.IFilterService;
        restrict = "E";
        scope = {
            name: "@",
            attr: "@",
            client: "=ngModel",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            onIndicatorClick: "&"
        };

        require = ["?^form", "^ngModel"];

        templateUrl = "app/components/search/clientDetailAccordionTemplate.html";

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        enableIntegratedRegister: boolean;
        public onIndicatorClick: () => {};


        constructor(private $rootScope: ng.IRootScopeService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,

            private appointmentBookActionsSevice: any,
            private securityService: Meevo.Components.Common.ISecurityService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            private $q,
            protected reportRouterService: Meevo.Components.Common.ReportRouterService,
            protected $filter: angular.IFilterService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService) {
        }

        showDocsAndFormsWorker(appointmentServices, formCollectionState: Meevo.Plugins.AppointmentBook.FormCollectionStateEnum = Meevo.Plugins.AppointmentBook.FormCollectionStateEnum.Checkin,
                               includePromptForms: boolean = false, forceDisplay: boolean = false) {
            let defer = this.$q.defer();

            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_FORMS)
                .then((result) => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                        let clientAppointmentServices = _(appointmentServices).where({clientType: Meevo.Model.ClientTypeEnum.Client});
                        if (clientAppointmentServices.length > 0 || forceDisplay) {
                            let request: any = {
                                "AppointmentServicesList": _(clientAppointmentServices).pluck("id"),
                                "TriggerEventEnum": Meevo.Model.DocsAndFormsTriggerEventEnum.Booked
                            };
                            if (!includePromptForms) {
                                request.isRequired = true;
                            }
                            this.dataService.customMethodData("api/DocsAndForms/AppointmentServiceForm/List", "post", request
                            ).then((formsResponse) => {
                                let formsToDisplay = forceDisplay ? formsResponse.data : _(formsResponse.data).filter((form) => !form.isSubmitted);
                                if (formsToDisplay.length > 0 || forceDisplay) {
                                    let modalOptions: Meevo.Components.Modal.IModalOptions = {
                                        templateUrl: "app/plugins/AppointmentBook/views/DocsAndForms.html",
                                        controller: "meevo.plugins.appointmentBook.DocsAndFormsController",
                                        controllerAs: "vm",
                                        bindToController: true,
                                        locals: {
                                            forms: formsToDisplay,
                                            formCollectionState: formCollectionState,
                                            request: request,
                                            appointmentServices: null,
                                            iframeCallback: () => defer.resolve()
                                        }
                                    };
                                    this.modalService.showCustom(modalOptions).then(() => defer.resolve());
                                }
                                else {
                                    defer.resolve();
                                }
                            });
                        }
                        else {
                            defer.resolve();
                        }
                    } else {
                        defer.resolve();
                    }
                });

            return defer.promise;
        }

        showCustomControls(appointmentServices, forCheckout: boolean, forCheckin: boolean) {
            var defer = this.$q.defer();
            const appArea = forCheckout ? Meevo.Model.AppAreaEnum.Checkout : Meevo.Model.AppAreaEnum.Checkin;
            let appointmentServicesWithCustomControls =
                _.filter(appointmentServices, (apptServ: any) =>
                { return (forCheckout && apptServ.hasCheckoutCustomControls === forCheckout) || (forCheckin && apptServ.hasCheckinCustomControls === forCheckin) });
            if (appointmentServicesWithCustomControls.length > 0) {
                let modalOptions: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/AppointmentBook/views/CustomFields.html",
                    controller: "meevo.plugins.appointmentbook.CustomFieldsController",
                    controllerAs: "vm",
                    bindToController: true,
                    additionalClassName: 'appointment-custom-fields-modal',
                    locals: {
                        appointDetails: appointmentServicesWithCustomControls,
                        appArea: appArea,
                        canEdit: true,
                        forceCancel: true
                    }
                };
                this.modalService.showCustom(modalOptions)
                    .then((response) => {
                        if (response.proceed == 1) {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    });
            } else {
                defer.resolve({ proceed: true });
            }
            return defer.promise;
        }

        saveCustomControls(customControls, saleLineId, appointmentId, appointmentServiceId, appArea: Meevo.Model.AppAreaEnum) {
            if (customControls) {
                customControls.answers.forEach((answer) => {
                    answer.entity_Id = saleLineId;
                    answer.auditEntityId = appointmentId;
                    answer.auditSubEntityId = appointmentServiceId;
                    answer.appAreaEnum = appArea;
                });
                let data = {
                    answers: customControls.answers,
                    answerItems: customControls.answerItems
                };

                return this.dataService.add(`customData/Answer`, data);
            } else {
                var defer = this.$q.defer();
                defer.resolve({ proceed: true });
                return defer.promise;
            }
        }

        link = (scope: any, element: JQuery, attr: angular.IAttributes, ctrl: ISearchController) => {
            scope.transactionHistory = {};
            scope.transactionHistoryFound = false;
            scope.transactionHistoryLoading = false;
            //scope.giftCardHistoryFound = false;
            scope.criteria = { showOnlyFutureAppts: true };
            scope.lastVisitDate;
            scope.locationId = this.identityService.current().locationId;
            scope.isCentralOffice = this.identityService.inCentralOfficeMode();
            scope.clientAppointments = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "appointmentservice", (pageNumber, items)=> {
                items.forEach(item=> {
                    item.isAppointmentInFuture = moment(item.startDateTime).startOf("day") >= moment().startOf("day").add(1, "days");
                });
            });
            scope.clientAlerts = [];
            scope.clientTypes = [];
            scope.alertsExpanded = false;
            scope.meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
            scope.canEditClient = false;
            scope.clientPointAlerts = [];
            this.clientVisitFilter = this.$filter('clientVisitDate') as angular.IFilterService;
            scope.currentTab = 1;

            scope.isSmsEnabled = false;
            scope.isClientSmsOptedIn = false;
            scope.isTextelOrTwoWaySmsEnabled = false;
            scope.meevoMessengerSecurityKey = null;

            scope.initializeMessage = () => {
                return (this.identityService.current().locationName + ":  ");
            }
            scope.smsMessage = scope.initializeMessage();

            this.dataService.customMethodData(`/api/Tenant/BusinessInfo/Settings`, "get", null).then(response => {
                this.enableIntegratedRegister = response.data.registerSettings.enableIntegratedRegister;
            });

            scope.$on(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU_COMPLETE, () => {
                //NOTE: When false, scope is reinitialized
                // Currently the requirement is to always preserve the last state
                //scope.$parent.vm.displayAccordion = false;
            });

            scope.$watch("$parent.vm.displayAccordion", displayAccordion => {
                if (!displayAccordion) {
                    scope.displayAppts = false;
                    scope.displayHistory = false;
                    scope.displayAlerts = false;
                    scope.transactionHistory = {};
                    scope.criteria.showOnlyFutureAppts = true;
                    scope.displayAlerts = false;
                    scope.clientAlerts = [];
                    scope.clientTypes = [];
                    scope.displayTextMsgTab = false;
                    scope.isSmsEnabled = false;
                    scope.isClientSmsOptedIn = false;
                    scope.smsMessage = null;
                } else {
                    this.dataService.getSectionById("client", scope.client.id, "alerts").then((clientAlerts: any) => {
                        if (clientAlerts.length > 0) {
                            for (var i = 0; i < clientAlerts.length; i++) {
                                scope.clientAlerts.push({
                                    alertType: clientAlerts[i].clientAlertType,
                                    alertMessage: this.$translate.instant("CLIENT_ALERT_" +
                                        ClientAlertTypeEnum[clientAlerts[i].clientAlertType].toUpperCase())
                                });
                            }
                            //scope.displayAlerts = true;
                        }
                    });
                    scope.getLastVisitDate();

                    this.dataService.getSectionById("client", scope.client.id, "ClientTypes").then((clientTypes: any) => {
                        scope.clientTypes = clientTypes;
                    });

                    scope.checkIsSmsEnabled();
                    scope.checkIsClientSmsOptedIn();

                    // display landing tab - it may be different based on user 'Client Find' feature selection in meevo app via convobar, client profile or appointment book.
                    if (scope.$parent.vm.landingTab == Meevo.Model.NounEnum.ClientFindSendTextMsgTab) { /* landing tab when accessed via 'Client Profile' */
                        scope.displayTextMsgTab = true;
                    }
                    else { /* default landing tab when NOT accessed via 'client profile' */
                        scope.displayAppts = true;
                        scope.loadClientAppointments(true);
                    }

                    // reset landing tab
                    scope.$parent.vm.setDefaultLandingTab();

                    var angularEl = angular.element('.client-find-tab')[0];
                    window.setTimeout(() => {
                        angularEl.focus();
                    }, 0);
                }
            });

            const messengerKeys: string[] = [
                scope.meevoSecurityKeys.INTEGRATION_TWOWAYSMS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                scope.meevoSecurityKeys.INTEGRATION_TEXTEL + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            ];
            this.securityService.checkAndCache(messengerKeys)
                .then((result: Model.SecurityItem[]) => {
                    let twoWaySecItem = result.find((item) => item.key === messengerKeys[0]);
                    let textelSecItem = result.find((item) => item.key === messengerKeys[1]);

                    if (twoWaySecItem.securityAccess !== Meevo.Model.SecurityAccessEnum.Hide) {
                        scope.meevoMessengerSecurityKey = scope.meevoSecurityKeys.INTEGRATION_TWOWAYSMS;
                    } else {
                        scope.meevoMessengerSecurityKey = scope.meevoSecurityKeys.INTEGRATION_TEXTEL;
                    }

                    scope.isTextelOrTwoWaySmsEnabled = twoWaySecItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant || textelSecItem.securityAccess == Meevo.Model.SecurityAccessEnum.Grant;
                });

            var clientEditKey = Meevo.Components.Common.SecurityKeys.DATA_CLIENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.securityService.checkSecurityKey(clientEditKey).then(result => {
                scope.canEditClient = result === Meevo.Model.SecurityAccessEnum.Grant;
            });

            /**
            *  Opens client profile for currently selected client.
            **/
            scope.sendToClient = (alertType: any): void => {
                var actionStateParam = Meevo.Model.MaintenanceFormState.Readonly;
                //if (scope.canEditClient) {
                //  actionStateParam = Meevo.Model.MaintenanceFormState.Editing;
                //}

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.client,
                    stateParams: {
                        callback: null,
                        callbackState: null,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        actionState: actionStateParam,
                        id: scope.client.id
                    },
                    clientAlertType: (_.isNumber(alertType) ? alertType : null)
                });

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
                //scope.$parent.vm.displayAccordion = false;
                scope.usageTrackingLog(Meevo.Model.NounEnum.ClientFindSendToClientProfile, Meevo.Model.VerbEnum.TabLoaded, null);
            }

            /**
            *  Send client to AppointmentBook > AppointmentEditor section
            **/
            scope.sendToEditor = (appointment: any): void => {
                var appointmentDate = new Date(appointment.startDateTime);
                appointmentDate.setHours(0, 0, 0, 0);

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
                //scope.$parent.vm.displayAccordion = false;

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.appointmentBook,
                    stateParams: {
                        actionState: Model.AppointmentBookState.EditAppointment,
                        actionStatePayload: {
                            finalState: appointment.finalState,
                            id: appointment.id, // DetailId
                            appointmentId: appointment.appointmentId, // HeaderId
                            appointmentServiceScheduleId: appointment.appointmentServiceScheduleId, // Standing Definition Id/Service Schedule Id
                            appointmentScheduleEntityVersion: appointment.appointmentScheduleEntityVersion,
                            appointmentDate: appointmentDate,
                            employeeId: appointment.employeeId
                        }
                    }
                });
            }

            /**
            *  Send client to AppointmentBook > Delete Modal
            **/
            scope.sendToDelete = (appointment: any): void => {

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.appointmentBook,
                    stateParams: {
                        actionState: Model.AppointmentBookState.DeleteAppointment,
                        actionStatePayload: {
                            id: appointment.id,
                            appointmentServiceScheduleId: appointment.appointmentServiceScheduleId, // Standing Definition Id/Service Schedule Id
                            appointmentScheduleId: appointment.appointmentScheduleId,
                            appointmentScheduleEntityVersion: appointment.appointmentScheduleEntityVersion,
                            appointmentDate: new Date(appointment.startDateTime).setHours(0, 0, 0, 0),
                            appointmentId: appointment.appointmentId,
                            employeeId: appointment.employeeId
                        }
                    }
                });

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
                //scope.$parent.vm.displayAccordion = false;
            }


            scope.isSingleLocation = (): boolean => {
                if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                    return this.identityService.current().isSingleLocation;
                else
                    return false;
            }


            /**
            * Loads Client History for the currently selected client.
            */
            scope.loadTransactionHistory = (toggleDetails: boolean): void => {
                scope.transactionHistoryFound = false;

                if (toggleDetails) {
                    scope.displayAppts = false;
                    scope.displayHistory = true;
                    scope.displayAlerts = false;
                    scope.displayTextMsgTab = false;
                    scope.currentTab = 2;
                }

                if (scope.displayHistory) {

                    let request = {
                        pageNumber: 0,
                        itemsPerPage: 10,
                        criteria: {
                            isGlobal: true
                        },
                        sortDirection: Meevo.Model.SortDirection.Descending

                    };
                    scope.transactionHistoryLoading = true;
                    this.dataService.getListPaged("/Client/" + scope.client.id + "/TransactionHistory", request).then((data) => {
                        scope.transactionHistoryLoading = false;
                        if (data && data.length > 0) {
                            scope.transactionHistory = data;
                            scope.transactionHistoryFound = true;
                        }
                        else {
                            scope.transactionHistoryFound = false;
                        }

                    });
                }

                scope.usageTrackingLog(Meevo.Model.NounEnum.ClientFindTransactionHistoryTab, Meevo.Model.VerbEnum.TabLoaded, null);
            }

            scope.concatenateDisplayName = (history: any): any => {
                if (history && (history.employeeCode || history.employeeFirstName || history.employeeLastName)) {
                    if ( history.employeeCode == undefined)
                        return  `${history.employeeLastName}, ${history.employeeFirstName}`;
                    return `${history.employeeCode} : ${history.employeeLastName}, ${history.employeeFirstName}`;
                }
                else {
                    return this.$translate.instant("LABEL_SALES_RANKINGS_HOUSE");
                }
            }


            /** 
            * Toggle Alerts of client 
            */
            scope.loadAlerts = (toggleDetails: boolean): void=> {
                if (toggleDetails) {
                    scope.displayAppts = false;
                    scope.displayHistory = false;
                    scope.displayAlerts = true;
                    scope.displayTextMsgTab = false;
                    scope.currentTab = 3;
                }

                scope.usageTrackingLog(Meevo.Model.NounEnum.ClientFindAlertsTab, Meevo.Model.VerbEnum.TabLoaded, null);
            }
            /**
            * Loads Client Appointments for the currently selected client.
            */
            scope.loadClientAppointments = (toggleDetails: boolean): void => {
                if (toggleDetails) {
                    scope.displayAppts = true;
                    scope.displayHistory = false;
                    scope.displayAlerts = false;
                    scope.displayTextMsgTab = false;
                    scope.currentTab = 1;
                }

                if (scope.displayAppts) {

                    var apptFinalStates = scope.criteria.showOnlyFutureAppts
                        ? [Meevo.Model.AppointFinalStateEnum.None, Meevo.Model.AppointFinalStateEnum.CheckedOut]
                        : [Meevo.Model.AppointFinalStateEnum.None, Meevo.Model.AppointFinalStateEnum.CheckedOut, Meevo.Model.AppointFinalStateEnum.Cancelled];

                    let request = {
                        pageNumber: 0,
                        itemsPerPage: 10,
                        includeActive: true,
                        sortDirection: scope.criteria.showOnlyFutureAppts ? Meevo.Model.SortDirection.Ascending : Meevo.Model.SortDirection.Descending,
                        criteria: {
                            futureAppointmentsOnly: scope.criteria.showOnlyFutureAppts,
                            clientId: scope.client.id,
                            localAppointmentsOnly: false,
                            finalStates: apptFinalStates
                        }
                    }

                    // Execute request
                    scope.clientAppointments.initSearch(request);
                }

                scope.usageTrackingLog(Meevo.Model.NounEnum.ClientFindAppointmentHistoryTab, Meevo.Model.VerbEnum.TabLoaded, null);
            }

            scope.routeToReport = (): void => {
                // Initialize params
                let startDate = moment();
                // Pre-populate data search for 90 days out
                let endDate = moment(startDate).add(90, 'd');
                let selectedClient = {
                    id: scope.client.id,
                    firstName: scope.client.firstName,
                    lastName: scope.client.lastName,
                    displayName: scope.client.displayName
                };
                // Build payload
                var data = [];
                data["startDateTime"] = startDate.toDate().toDateString();
                data["endDateTime"] = endDate.toDate().toDateString();
                data["clients"] = [selectedClient];
                data["pageBreak"] = false;
                data["apptsAllLocations"] = true;
                this.reportRouterService.routeToReport(this.meevoSecurityKeys.REPORTS_APPOINTMENTS_AQ025, data)
                    .then(result => {
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
                    });
            }

            /**
            * Loads Client last visit date.
            */
            scope.getLastVisitDate = (): void => {
                let request = {
                    criteria: {
                        client_Id: scope.client.id,
                    }
                }

                // Execute request
                this.dataService.getItem("client", scope.client.id, "visitdate").then((response: any) => {
                    scope.lastVisit = response;
                    let unparsedDate: any = this.clientVisitFilter(response.lastVisitDate);
                    scope.timeInPast = unparsedDate.slice(21);
                    scope.lastVisitDate = unparsedDate.slice(0, 20);
                });

            }

            scope.loadVisitNotes = () => {
                event.stopPropagation();
                scope.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, scope.client.id, "SECTION_CLIENT_VISIT_NOTES", null, null, scope.client.displayName, null);
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
            }

            /**
             * Handles printing of an appointment service ticket for the specified appointment.
             * @param appointment 
             * @returns {} 
             */
            scope.printAppointmentServiceTicket = (appointment: any): void => {
                this.appointmentBookActionsSevice.printWorkTicket(appointment.appointmentId);
            }

            /**
            * Handles the user experience for checking in 1-N appointments.
            */
            scope.checkinAppointmentService = (appointment: any): void => {
                let startDateMoment = moment(appointment.startDateTime);
                let startDate = startDateMoment.toDate().toDateString();
                let endDate = startDateMoment.add(1, 'd').toDate().toDateString();
                let isMultipleCheckIn = false;

                let searchCriteria: Model.AppointmentServiceSearchCriteria = {
                    clientId: scope.client.id,
                    startDate: startDate,
                    endDate: endDate,
                    transitionStates: [
                        Model.AppointStateEnum.Arrived,
                        Model.AppointStateEnum.Booked,
                        Model.AppointStateEnum.NoShow,
                        Model.AppointStateEnum.RunningLate
                    ],
                    finalStates: [
                        Model.AppointFinalStateEnum.None
                    ]
                };
                let request: Model.AppointmentServiceCount = {
                    criteria: searchCriteria
                };

                this.dataService.getListPaged("appointmentservice", request).then((services: any[]) => {
                    let appointmentNote = undefined;
                    if (services.length > 0) {
                        appointmentNote = {
                            displayName: scope.client.displayName,
                            noteText: services[0].noteText,
                            noteType: services[0].noteType
                        }
                    }
                    let clientNoteObj = {
                        clientId: scope.client.id,
                        clientType: scope.clientType,
                        displayName: scope.client.displayName,
                        noteType: Meevo.Model.ClientNoteViewTimeEnum.CheckIn
                    }
                    if (services.length === 1) {
                        scope.checkinSingleAppointmentService(appointment).then(() => {
                            this.appointmentBookActionsSevice.displayClientNote(clientNoteObj, false, true, appointmentNote);
                            scope.sendCheckedInMessage(appointment.id, isMultipleCheckIn);
                            scope.loadClientAppointments(false);
                        });
                    } else if (services.length > 1) {
                        this.modalService.confirm("MESSAGE_MULTIPLE_CHECKIN_PROMPT").then((result) => {
                            scope.checkinMultipleAppointmentServices(startDate, services).then(() => {
                                this.appointmentBookActionsSevice.displayClientNote(clientNoteObj, false, true, appointmentNote);
                                isMultipleCheckIn = true;
                                scope.sendCheckedInMessage(appointment.appointmentId, isMultipleCheckIn);
                                scope.loadClientAppointments(false);
                            });
                        }).catch((reason) => {
                            scope.checkinSingleAppointmentService(appointment).then(() => {
                                this.appointmentBookActionsSevice.displayClientNote(clientNoteObj, false, true, appointmentNote);
                                scope.sendCheckedInMessage(appointment.id, isMultipleCheckIn);
                                scope.loadClientAppointments(false);
                            });
                        });
                    }
                });

            }

            /**
            * Sends a message when an appointment check in is requested.
            */
            scope.sendCheckedInMessage = (id: any, isMultipleCheckIn: boolean): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLIENT_FIND_APPT_CHECKED_IN, id, isMultipleCheckIn);
            };

            /**
            * Handles check in of a single appointment.
            */
            scope.checkinSingleAppointmentService = (appointment: any): angular.IPromise<any> => {
                let dataService = this.dataService;

                return this.showDocsAndFormsWorker([appointment]).then(() => {
                    this.showCustomControls([appointment], false, true).then(() => {
                        // Set appointment indicator
                        //helper.setAppointStateIndicator(service.details.id, Meevo.Model.AppointStateEnum.CheckedIn, Meevo.Model.AppointFinalStateEnum.None);
                        this.saveCustomControls(appointment.customControlsAnswers, appointment.id, appointment.appointmentId, appointment.id, Meevo.Model.AppAreaEnum.Checkin);
                        //showCheckinNote(service.details.noteText, service.details.noteType);

                        let checkInSingleRequest = {
                            appointmentEntityVersion: appointment.appointmentEntityVersion,
                            model: {
                                TransitionState: Model.AppointStateEnum.CheckedIn
                            }
                        }

                        return dataService.patch("appointment/" + appointment.appointmentId + "/appointmentservice/" + appointment.id, checkInSingleRequest);
                    });
                });

            }

            /**
            * Handles check in of multiple appointments for the specified date.
            */
            scope.checkinMultipleAppointmentServices = (appointmentDate: any, services): angular.IPromise<any> => {
                return this.showDocsAndFormsWorker(services).then(() => {
                    this.showCustomControls(services, false, true).then(() => {
                        let checkInMultipleRequest = {
                            AppointmentDate: appointmentDate,
                            model: {
                                TransitionState: Model.AppointStateEnum.CheckedIn
                            }
                        }

                        return this.dataService.patch("client/" + scope.client.id + "/appointmentservice", checkInMultipleRequest);
                    });
                });
            }

            /**
            * Handles the user experience for checking out 1-N appointments.
            */
            scope.checkoutAppointmentService = (appointmentService: any): void => {
                if (appointmentService.isAppointmentInFuture) {
                    this.modalService.alert("MESSAGE_CHECKOUT_FUTURE_APPOINTMENT");
                    return;
                }

                if (this.enableIntegratedRegister) {
                    this.dataService.customMethodData(`/api/AppointmentService/${appointmentService.id}`, "get", null).then(response => {
                        // Launch register
                        this.appointmentBookActionsSevice.launchRegisterCheckout(response.data);
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
                    });
                }
                else {
                    this.modalService.confirm("MESSAGE_CHECKOUT_PROMPT").then((result) => {
                        let startDateMoment = moment(appointmentService.startDateTime);
                        let startDate = startDateMoment.toDate().toDateString();
                        let endDate = startDateMoment.add(1, 'd').toDate().toDateString();
                        let isMultipleCheckOut = false;

                        let searchCriteria: Model.AppointmentServiceSearchCriteria = {
                            clientId: scope.client.id,
                            startDate: startDate,
                            endDate: endDate,
                            transitionStates: [
                                Model.AppointStateEnum.Arrived,
                                Model.AppointStateEnum.CheckedIn,
                                Model.AppointStateEnum.Booked,
                                Model.AppointStateEnum.RunningLate,
                                Model.AppointStateEnum.NoShow,
                            ],
                            finalStates: [
                                Model.AppointFinalStateEnum.None
                            ]
                        };

                        let request: Model.AppointmentServiceCount = {
                            criteria: searchCriteria
                        };

                        this.dataService.getListPaged("appointmentservice", request).then((unfilteredAppointmentServices: any[]) => {
                            let appointmentServices = unfilteredAppointmentServices
                                .filter((service) => service.id === appointmentService.id || service.transitionState !== Meevo.Model.AppointStateEnum.NoShow);

                            if (appointmentServices.length === 1) {
                                this.showDocsAndFormsWorker([appointmentService]).then(() => {
                                    this.showCustomControls([appointmentService], true, false)
                                        .then(() => {
                                            scope.checkoutSingleAppointmentService(appointmentService)
                                                .then(() => {
                                                    scope.sendCheckedOutMessage(appointmentService.id, isMultipleCheckOut);
                                                    scope.loadClientAppointments(false);
                                                });
                                        });
                                });
                            } else if (appointmentServices.length > 1) {
                                this.modalService.confirm("MESSAGE_MULTIPLE_CHECKOUT_PROMPT").then((result) => {
                                    this.showDocsAndFormsWorker(appointmentServices).then(() => {
                                        this.showCustomControls(appointmentServices, true, false).then(() => {
                                            scope.checkoutMultipleAppointmentServices(appointmentService, startDate).then((response) => {
                                                let promises = [];
                                                response.forEach((appointmentService) => {
                                                    promises.push(this.saveCustomControls(_.findWhere(appointmentServices, { id: appointmentService.id }).customControlsAnswers,
                                                        appointmentService.saleLineId, appointmentService.appointmentId, appointmentService.id, Model.AppAreaEnum.Checkout));
                                                });
                                                this.$q.all(promises)
                                                    .then(() => {
                                                        isMultipleCheckOut = true;
                                                        scope.sendCheckedOutMessage(appointmentService.appointmentId, isMultipleCheckOut);
                                                        scope.loadClientAppointments(false);
                                                    });

                                            });
                                        });
                                    });
                                }).catch((reason) => {
                                    this.showDocsAndFormsWorker([appointmentService]).then(() => {
                                        this.showCustomControls([appointmentService], true, false)
                                            .then(() => {
                                                scope.checkoutSingleAppointmentService(appointmentService)
                                                    .then(() => {
                                                        scope.sendCheckedOutMessage(appointmentService.id, isMultipleCheckOut);
                                                        scope.loadClientAppointments(false);
                                                    });
                                            });
                                    });
                                });
                            }
                        });
                    });
                };
            }

            /**
            * Sends a message when an appointment check out is requested.
            */
            scope.sendCheckedOutMessage = (id: any, isMultipleCheckOut: boolean): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLIENT_FIND_APPT_CHECKED_OUT, id, isMultipleCheckOut);
            };


            /**
            * Handles check out of a single appointment.
            */
            scope.checkoutSingleAppointmentService = (appointmentService: any): angular.IPromise<any> => {
                let dataService = this.dataService;

                let checkOutSingleRequest = {
                    appointmentEntityVersion: appointmentService.appointmentEntityVersion,
                    model: {
                        TransitionState: appointmentService.transitionState,
                        FinalState: Model.AppointFinalStateEnum.CheckedOut
                    }
                }

                return dataService.patch("appointment/" + appointmentService.appointmentId + "/appointmentservicecheckout/" + appointmentService.id,
                    checkOutSingleRequest).then((response) => {
                        this.saveCustomControls(appointmentService.customControlsAnswers,
                            response.saleLineId, appointmentService.appointmentId, appointmentService.id, Model.AppAreaEnum.Checkout);
                    });
            }

            /**
            * Handles check out of multiple appointments for the specified date.
            */
            scope.checkoutMultipleAppointmentServices = (appointmentService: any, appointmentDate: any): angular.IPromise<any> => {
                // TODO: Replace w/ endpoint that can call AppointmentServiceLogic.CheckOutList
                let checkOutMultipleRequest = {
                    locationId: appointmentService.locationId,
                    clientGlobalId: scope.client.id,
                    appointmentDate: appointmentDate,
                    currentAppointmentServiceId: appointmentService.id,
                };

                return this.dataService.patch("client/" + scope.client.id + "/appointmentservicecheckout", checkOutMultipleRequest);
            }

            /**
            * Handles
            */
            scope.getClientTypes = () => {
                if (scope.client.id) {
                    let dataService = this.dataService

                    dataService.getItem("client/", scope.client.id).then((response) => {
                        return response
                    });
                }
            }
            scope.clientTypes = scope.getClientTypes();


            scope.openPackageHistory = (event, client) => {
                event.stopPropagation();
                scope.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.id, "SECTION_HISTORY", null, null, client.displayName, "PACKAGE_HISTORY");
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
            }

            scope.openGiftCardHistory = (event, client) => {
                event.stopPropagation();
                scope.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.id, "SECTION_HISTORY", null, null, client.displayName, "GIFTCARD_HISTORY");
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
            }

            scope.openCancelledOrNoShowAppointmentHistory = (event, client) => {
                event.stopPropagation();
                scope.goToState("client",
                    Meevo.Model.MaintenanceFormState.Readonly,
                    client.id,
                    "SECTION_HISTORY",
                    undefined,
                    undefined,
                    client.displayName,
                    "APPOINTMENT_HISTORY",
                    Meevo.Plugins.Client.ClientAppointmentHistoryFilterType.NoShowAndCancelled);
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
            }

            scope.goToState = (stateName, actionState, id: any = undefined, initialSection = "Main", clientAlertType: any = undefined, callback = undefined, clientDisplayName = null, initialSubSection: string = null, filter: number = undefined) => {
                this.$rootScope.$broadcast("gotoState", {
                    stateName: stateName,
                    stateParams: {
                        callback: callback,
                        callbackState: undefined,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        actionState: actionState,
                        id: id,
                        initialEditSection: initialSection,
                        initialEditSubSection: initialSubSection,
                        clientDisplayName: clientDisplayName,
                        filter: filter
                    },
                    clientAlertType: clientAlertType
                });
            }

            // Enable tabbing to switch sections
            scope.keyDown = (event: JQueryEventObject) => {
                if (!event.shiftKey && event.keyCode == 9) {
                    switch (scope.currentTab) {
                        case 1:
                            scope.loadTransactionHistory(true);
                            break;
                        case 2:
                            scope.loadAlerts(true);
                            break;
                        case 3:
                            scope.loadVisitNotes(true);
                            break;
                        default:
                            break;
                    }
                }
                // shift+tab
                if (event.shiftKey && event.keyCode == 9) {
                    switch (scope.currentTab) {
                        case 1:
                            scope.loadVisitNotes(true);
                            break;
                        case 2:
                            scope.loadClientAppointments(true);
                            break;
                        case 3:
                            scope.loadTransactionHistory(true);
                            break;
                        default:
                            break;
                    }
                }
            }

            scope.usageTrackingLog = (nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum, payload) => {
                var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, payload, scope.client.id);
                this.trackingService.saveTrackingInfo(trackingItem);
            }

            scope.displayCheckoutError = () => {
                this.modalService.alert("A future appointment cannot be checked out.");
            }

            scope.loadTextMsgTab = (toggleDetails: boolean): void => {
                if (toggleDetails) {
                    scope.displayAppts = false;
                    scope.displayHistory = false;
                    scope.displayAlerts = false;
                    scope.displayTextMsgTab = true;
                    scope.currentTab = 4;
                }

                scope.usageTrackingLog(Meevo.Model.NounEnum.ClientFindSendTextMsgTab, Meevo.Model.VerbEnum.TabLoaded, null);
                let contextArr = scope.$parent.$parent.$parent.$parent.main.contexts;
                let meevoMessengerContext =  contextArr.find(ctx => ctx.name == 'meevoMessenger')
                let mmControllerModel = scope.$parent.$parent.vm;


                if (meevoMessengerContext && meevoMessengerContext.status == 'active') {
                    mmControllerModel.closeMenu()
                    return
                };

                if (!scope.isTextelOrTwoWaySmsEnabled) return;

                const classification = scope.meevoMessengerSecurityKey === scope.meevoSecurityKeys.INTEGRATION_TEXTEL ? 'TEXTEL' : 'SMS';
                this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/meevomessenger/Setting?classification=${classification}`, 'GET', null)
                    .then(result => {
                        //if messenger is not initialized, display one way texting tool
                        if (!result.data.isAccountInitialized) return;
                        scope.openMeevoMessenger(classification, mmControllerModel);
                    })
            }

            scope.checkIsClientSmsOptedIn = () => {
                if (scope.client.phoneNumbers) {
                    scope.setIsClientSmsOptedIn(scope.client);
                }
                else {
                    this.dataService.getItem("client", scope.client.id)
                        .then((item: any) => {
                            scope.setIsClientSmsOptedIn(item);
                        });
                }
            }

            scope.setIsClientSmsOptedIn = (client: any) => {
                if (client && client.phoneNumbers) {
                    var phone = _.findWhere(client.phoneNumbers, { type: Model.PhoneTypeEnum.Mobile, useForSMS: true, smsOptInStateEnum: Model.CommunicationOptedInStateEnum.OptedIn });
                    if (phone) {
                        scope.isClientSmsOptedIn = true;
                    }
                }
            }

            scope.checkIsSmsEnabled = () => {
                this.dataService.customMethodData("api/notificationSetting", "GET", {}).then(result => {
                    scope.isSmsEnabled = result.data.isSmsEnabled;
                });
            }

            scope.sendSms = (): void => {
                this.dataService.customMethodData("api/Client/" + scope.client.id + "/OneWaySms", "POST", {
                    'smsMessage': scope.smsMessage
                }).then(result => {
                    if (result.data) {
                        this.modalService.alert("LABEL_CLIENTFIND_SENDSMS_SENT");
                        scope.smsMessage = scope.initializeMessage();
                    }
                });
            }

            scope.openMeevoMessenger = (classification: string, mmControllerModel): void => {
                event.stopPropagation();
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);

                const countryCode = scope.client.primaryPhoneNumberCountryCode || scope.client.countryCode;

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.meevoMessenger,
                    stateParams: {
                        id: scope.client.id,
                        firstName: scope.client.firstName,
                        lastName: scope.client.lastName,
                        primaryPhoneNumber: scope.client.primaryPhoneNumber,
                        countryCode,
                        isRestricted: scope.client.isRestricted,
                        isClient: true,
                        meevoFile: scope.client.meevoFile,
                        classification: classification,
                    }
                });

                mmControllerModel.closeMenu();
                scope.usageTrackingLog(Meevo.Model.NounEnum.ClientFindSendToTextel, Meevo.Model.VerbEnum.TabLoaded, null);
            }

        }   

        static factory(): angular.IDirectiveFactory {
          let directive = ($rootScope, appSettings, dataService, modalService, $translate, appointmentBookActionsSevice, securityService, identityService, $q, reportRouterService, $filter, trackingService) => {
                return new MeevoClientDetailAccordion($rootScope, appSettings, dataService,
                  modalService, $translate, appointmentBookActionsSevice, securityService, identityService, $q, reportRouterService, $filter, trackingService);
            };

            directive.$inject = ["$rootScope", "meevo.AppSettings",
                "meevo.components.common.DataService",
                "meevo.components.modal.ModalService",
                "$translate",
                "appointmentBookActionsService",
                'meevo.components.common.SecurityService',
                'meevo.components.common.IdentityService',
                "$q",
                "meevo.components.common.ReportRouterService",
                "$filter",
                "meevo.components.tracking.TrackingService"
            ];

            return directive;
        }
    }

    angular.module("meevo.components.search")
        .directive("meevoClientDetailAccordion", MeevoClientDetailAccordion.factory());
}